import logo from './logo.svg';
import './App.css';
import { Box, Button, Card, CardActionArea, CardContent, CardMedia, FormControl, Grid, Stack, TextField } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import CargoTrackingInfo from './pages/CargoTrackingInfo';
import Api from './api/Api';
import ReCAPTCHA from 'react-google-recaptcha';
import './Custom.css'
import { toast } from 'react-toastify';

function App() {

  const [shipmentNumber, setShipmentNumber] = useState(null);
  const [enterClick, setEnterClick] = useState(false);


  const [buttonCheck, setButtonCheck] = useState(false);
  const reRef = useRef();
  const ReCaptcha = async () => {
    const token = await reRef.current.executeAsync();
    reRef.current.reset();
    var response = await Api.post('/Recaptcha/Validate', {
      token: token
    }).then(r => r.data).catch(console.error)
    if (response.result.success == true) {
      return true;
    }
    else {
      setButtonCheck(!buttonCheck); toast.error("Google Recaptcha Hatası Alındı");
    }
  }
  useEffect(() => { ReCaptcha() }, [])

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      setEnterClick(true)
    }
    else {
      setEnterClick(false);
    }
  };


  // useEffect(() => {
  //   // Query parametrelerini almak için
  //   const queryParams = new URLSearchParams(window.location.search);
  //   const param1 = queryParams.get('param1');
  //   const param2 = queryParams.get('param2');

  //   // Hash parametresini almak için
  //   const hashParams = new URLSearchParams(window.location.hash.substr(1));
  //   const hashParam1 = hashParams.get('hashParam1');
  //   const hashParam2 = hashParams.get('hashParam2');

  //   console.log('Query param1:', param1);
  //   console.log('Query param2:', param2);
  //   console.log('Hash param1:', hashParam1);
  //   console.log('Hash param2:', hashParam2);
  // }, []);

  const handleDincer = async () => {
    window.open('https://www.dincerlojistik.com.tr/', '_blank', 'noreferrer')
  }
  const handleFacebook = async () => {
    window.open('https://www.facebook.com/dincerlojistik', '_blank', 'noreferrer')
  }
  const handleLinkedin = async () => {
    window.open('https://tr.linkedin.com/company/dincerlojistik', '_blank', 'noreferrer')
  }
  const handleInstagram = async () => {
    window.open('https://www.instagram.com/dincer_lojistik/', '_blank', 'noreferrer')
  }
  const handleYoutube = async () => {
    window.open('https://www.youtube.com/channel/UCCKSnSG6YUSjtlF0tQiLo_A', '_blank', 'noreferrer')
  }

  const backgroundImage = {
    backgroundImage: 'url(/dincer.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100vh',
    width: '100vw',
  };

  return (
    <div style={backgroundImage}>
      <Box sx={{ flexGrow: 1 }} style={{ padding: 1 }} >
        <Grid container spacing={1}>

          <Grid item sm={4} xs={4}>
            <div style={{}} >
              <img id='DincerLogo'
                alt='Logo'
                src={"https://cdn.dincerlojistik.com/apps/sharingpath/admin/public/corporate/dl_full_w_logo.png"}
              />
            </div>
          </Grid>
          <Grid item sm={4} xs={12}>
            <Card elevation={20} sx={{ maxWidth: 550, margin: 'auto', borderRadius: 3, p: 3 }} style={{ marginTop: "9rem", background: 'rgba(255, 255, 255, 0.9)' }}>
              <CardContent>
                <div>
                  <h2>Hoşgeldiniz</h2>
                </div>
                <Grid container spacing={1}>
                  <Grid item sm={12} xs={12}>
                    <FormControl fullWidth size="small" id='DincerForm'>
                      <TextField disabled={buttonCheck} onKeyDown={handleKeyDown} id='ShipmentNumber' size="medium" autoComplete="false" fullWidth label="Gönderi Takip Numarası" value={shipmentNumber} onChange={(e) => { setShipmentNumber(e.target.value) }} />
                    </FormControl>
                  </Grid>
                  <Grid item sm={2} xs={2}></Grid>
                  <Grid item sm={8} xs={8}>
                    <FormControl fullWidth id='DincerForm'>
                      {/* <Button size='large' variant="outlined">Sorgula</Button> */}
                      <CargoTrackingInfo shipmentNumber={shipmentNumber} setShipmentNumber={setShipmentNumber} enterClick={enterClick} setEnterClick={setEnterClick} />
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item sm={4} xs={6}>
            <div id='GonderiTakipAdi' >
              <h1>Gönderi Takip</h1>
            </div>
          </Grid>
          <Grid item sm={11} xs={12}></Grid>
          <Grid item sm={1} xs={12}>
            <Card elevation={5} sx={{ maxWidth: 40, margin: 'auto', borderRadius: 3, p: 2 }} style={{ marginTop: "3rem", background: 'rgba(255, 255, 255, 0.3)' }}>
              <Stack direction="column" justifyContent="center" spacing={2}>
                <img
                  style={{
                    maxHeight: "2rem", cursor: "pointer", maxWidth: "2rem"
                  }}
                  alt='Logo'
                  className='h-35px logo'
                  src={"https://cdn.dincerlojistik.com/apps/sharingpath/admin/public/corporate/icons/internet.png"}
                  onClick={handleDincer}
                />

                <img
                  style={{
                    maxHeight: "2rem", cursor: "pointer", maxWidth: "2rem"
                  }}
                  alt='Logo'
                  className='h-35px logo'
                  src={"https://cdn.dincerlojistik.com/apps/sharingpath/admin/public/corporate/icons/facebook.png"}
                  onClick={handleFacebook}
                />

                <img
                  style={{
                    maxHeight: "2rem", cursor: "pointer", maxWidth: "2rem"
                  }}
                  alt='Logo'
                  className='h-35px logo'
                  src={"https://cdn.dincerlojistik.com/apps/sharingpath/admin/public/corporate/icons/instagram.png"}
                  onClick={handleInstagram}
                />
                <img
                  style={{
                    maxHeight: "2rem", cursor: "pointer", maxWidth: "2rem"
                  }}
                  alt='Logo'
                  className='h-35px logo'
                  src={"https://cdn.dincerlojistik.com/apps/sharingpath/admin/public/corporate/icons/linkedin.png"}
                  onClick={handleLinkedin}
                />

                <img
                  style={{
                    maxHeight: "2rem", cursor: "pointer", maxWidth: "2rem"
                  }}
                  alt='Logo'
                  className='h-35px logo'
                  src={"https://cdn.dincerlojistik.com/apps/sharingpath/admin/public/corporate/icons/youtube.png"}
                  onClick={handleYoutube}
                />
              </Stack>
            </Card>
          </Grid>
        </Grid>

      </Box >
      <ReCAPTCHA
        sitekey={"6LeFfC0mAAAAABJmDD7CUtquCubYoNELD6-1XpXM"}
        size="invisible"
        ref={reRef}
      />
    </div>
  );
}

export default App;
